import { Modal, Text, Group, Button } from '@mantine/core';

function DeleteConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Delete Confirmation',
  message = 'Are you sure you want to delete this item? This action cannot be undone.'
}) {
  return (
    <Modal opened={isOpen} onClose={onClose} title={title} size="sm">
      <Text mb="lg">{message}</Text>
      <Group w="100%" justify="space-between">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
}

export default DeleteConfirmationModal; 